import {
    Container,
    Grid,
    Box,
    TextField,
    Button,
    Snackbar,
    Switch,
    Card,
    CardActions,CardMedia
  } from "@material-ui/core";
  import { useState,useEffect } from "react";
  import CKEditor from "react-ckeditor-component";
  import MuiAlert from "@material-ui/lab/Alert";
  import Axios from "axios";
  import { useNavigate,useParams } from "react-router-dom";
  import { Helmet } from "react-helmet";
  const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";
  
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  let greenColor = {
    color: "green",
    fontWeight: "bold",
  };
  
  let blackColor = {
    color: "black",
  };

export const UpdateArticle=()=>{
  let { id } = useParams();
  console.log("update")
    // const[id,setId]= useState("")
    const[title,setTitle] = useState("")
 const [content, setContent] = useState("");
 const[articles,setArticles] = useState([])
 const [artical,setArtical] = useState([])
 const [images, setImages] = useState([])
    const [uploadwait, setUploadWait] = useState(false);
 const [oldImages, setOldImages] = useState("");
    const [imageids, setImageIds] = useState("");
 const [err, setErr] = useState(0);
 const [disablebutton, setDisablebutton] = useState(false);
 const [snackBar, setSnackBar] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState("success");
  const [snackBarType, setSnackBarType] = useState("Invalid");
  const navigate = useNavigate();
  const openSnkbar = (type, msg) => {
    setSnackBarMsg(msg);
    setSnackBarType(type);
    setSnackBar(true);
  };
  const handleChange = (evt) => {
    const newContent = evt.editor.getData();
    setContent(newContent);
  };
  useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    const formData = new FormData();
    formData.append("idd", id);
    Axios.post("/api/select_single_article", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        console.log(res.data.data)
        // setId(res.data.data.id)
        setTitle(res.data.data.article_title)
        setContent(res.data.data.article_description)
        setImageIds(res.data.data.article_images)
          setOldImages(res.data.data.article_images)
      }
    })
}
const imageChange = async (e) => {
  
  if (e.target.files.length != 0) {
    // console.log(oldImages.split(",").length)
    // if (oldImages.split(",").length + images.length + e.target.files.length <= 3) {
    console.log(oldImages.length)
    console.log(oldImages)
    
    if (oldImages.split(",").length + articles.length + e.target.files.length <= 5) {
      var arr = [];

      for (var i = 0; i < e.target.files.length; i++) {
        var type = e.target.files[i].type;

        if (type === "image/jpeg" || type === "image/jpg" || type === "image/png") {
          const image = e.target.files[i];
          // var img = await compImage(image);
          arr.push({ raw: image, preview: URL.createObjectURL(image) });
        } else {
          alert("Please select only JPEG, JPG, PNG Images..")
        }
      }
      console.log("arr", arr)
      setImages([...articles, ...arr]);
    } else {
      alert("Maximum Image limit is 5.");

    }
  }
  e.target.value = ""
};
const onSubmit = ()=>{
    setErr(0)
    if(title==""){
      setErr(1);
      openSnkbar("error", "Please Enter Article Title....");
  }else if(content==""){
      setErr(2);
    openSnkbar("error", "Please Enter Article Description....");
  }else if (articles.length== 0 ) {
      setErr(3);
      openSnkbar("error", "Please Select  Article Image....");
    }else{
      openSnkbar("warning", "Please wait.....");
      setDisablebutton(true);
      const formData = new FormData();
      formData.append('images', imageids);
        for (var i = 0; i < articles.length; i++) {
          console.log("i", i)
          formData.append('images', images[i].raw);
        }
        formData.append("title", title);
        formData.append("description",content );
        Axios.post("/api/add_article", formData, {
          headers: { headKey: headKey },
        }).then((res) => {
          if (res.data.status) {
            setDisablebutton(false);
            openSnkbar("success", res.data.msg);
            navigate("/dash/allarticles");
          } else {
            setDisablebutton(false);
            openSnkbar("error", "Something went wrong... try later.");
          }
        }); 
}
}
return(
  <Container>
  <Helmet>
    <title>Add Service - Admin | Arawinz Soft Solutions</title>
    <meta
      name="description"
      content="Arawinz Soft Solutions is one of the finest Software Development company. We provide services in Web Development-Full Stack, Web Designing (Static & Responsive), Mobile App Development, Social Media Marketing, SEO, Data Analytics,  CRM, ERP, Mobile Gaming and Artificial Intelligence."
    />
    <meta
      name="keywords"
      content=" Testimonials Top Web Development company in Gachibowli, SEO companies in Hyderabad, Best Application development company in India, Top 5 development companies in Vizag, Digital and Social Media Marketing, Data Analytics company in Hitech city, Graphics Design and Gaming company in Jubilee hills, Best Artificial Intelligence company in Hyderabad, Top gaming organization near me, Available ERP &amp; CRM developers Madhapur"
    ></meta>
  </Helmet>
  <Box boxShadow={3} p={3} m={4} style={{ border: "2px solid #333333" }}>
      <Snackbar
        open={snackBar}
        autoHideDuration={4000}
        onClose={() => {
          setSnackBar(false);
        }}
      >
        <Alert
          onClose={() => {
            setSnackBar(false);
          }}
          severity={snackBarType}
          style={{
            color: snackBarType === "warning" ? "black" : "white",
          }}
        >
          {snackBarMsg}
        </Alert>
      </Snackbar>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={4}
      >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <h2
            style={{
              textDecoration: "underline",
              marginBottom: "0px",
              textAlign: "center",
            }}
          >
            Edit Article
          </h2>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            id="filled-required"
            label="Title"
            variant="filled"
            error={err === 1 && true}
            value={title}
            size="small"
            onChange={(e) => {
              setTitle(e.target.value);
            }}
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <CKEditor
            activeClass="p10"
            content={content}
            config={{
              toolbar: [
                {
                  name: "document",
                  items: [
                    "Source",
                    "-",
                    "NewPage",
                    "Preview",
                    "-",
                    "Templates",
                  ],
                },
                {
                  name: "clipboard",
                  items: [
                    "Cut",
                    "Copy",
                    "Paste",
                    "PasteText",
                    "PasteFromWord",
                    "-",
                    "Undo",
                    "Redo",
                  ],
                },
                {
                  name: "styles",
                  items: ["Styles", "Format", "Font", "FontSize"],
                },
                {
                  name: "basicstyles",
                  items: [
                    "Bold",
                    "Underline",
                    "Italic",
                    "Strike",
                    "Subscript",
                    "Superscript",
                    "-",
                    "RemoveFormat",
                  ],
                },
                {
                  name: "colors",
                  items: ["fontColor", "fontBackgroundColor"],
                },
                { name: "links", items: ["Link", "Unlink", "Anchor"] },
                {
                  name: "insert",
                  items: ["Image", "Table", "HorizontalRule", "SpecialChar"],
                },
                { name: "tools", items: ["Maximize"] },
                { name: "others", items: ["-"] },
                { name: "about", items: ["About"] },
              ],
              height: 300,
              width:800,
            }}
            events={{
              change: handleChange,
            }}
          />
        </Grid>
        <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
          { oldImages.split(",").map((article)=>(
            <Card>
              <img width="250px" height="250px" src={"/static/articles/"+article} />
            <CardActions><Button variant="contained"
            color="primary"
            onClick={()=>{
              const formData= new FormData()
              formData.append("idd",id)
              formData.append("image_name",article)
              Axios.post("/api/delete_article_image", formData, {
                headers: { headKey: headKey },
              }).then((res) => {
                if (res.data.status) {
                  setDisablebutton(false);
                  openSnkbar("success", res.data.msg);
                getData()
                } else {
                  setDisablebutton(false);
                  openSnkbar("error", "Something went wrong... try later.");
                }
              }); 
            }}>delete</Button></CardActions></Card>
            // <img width="250px" height="250px" src={"/static/articles/"+article} />
          )) }
          { articles.length!=0 && articles.map((article)=>(
            <img width="250px" height="250px" src={article} />
          )) }
          <br />
          <br />

          <input
            accept="image/*"
            multiple
            style={{ display: "none" }}
            onChange={imageChange}
            id="contained-button-file"
            type="file"
          />
          <label htmlFor="contained-button-file">
            <Button variant="contained" color="primary" component="span">
              Upload Image
            </Button>
          </label>
          {err === 3 && (
            <div style={{ color: "red" }}>Please select a file.</div>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Button
            onClick={onSubmit}
            variant="contained"
            color="primary"
            disabled={disablebutton}
          >
            {disablebutton ? "Please wait.." : "Edit Article"}
          </Button>
        </Grid>
        </Grid>
        </Box>
  </Container>
)
}

